import { Component, ViewEncapsulation } from '@angular/core';

import { MobileNavigationEvent } from 'src/app/core/events/events';
import { IMobileNavigationEventModel } from 'src/app/core/models/models';
import { AppUtilityService } from 'src/app/core/services/app-utility/app-utility.service';
import { EventsService } from 'src/app/core/services/events.service';
import { AARouterURL } from 'src/app/modules/app-routing/enums/routing.enum';
import { AppRouterDataService } from 'src/app/modules/app-routing/services/app-router-data/app-router-data.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  standalone: false
})
export class HeaderComponent {
  isDesktop = true;
  constructor(
    public _appUtilityService: AppUtilityService,
    public appRouterDataService: AppRouterDataService,
    public eventsService: EventsService,
  ) {
    this.isDesktop = this._appUtilityService.isDeviceCheck();
  }

  public goToRoutePlanner(): void {
    this.appRouterDataService.updateURL(AARouterURL.ROUTE_PLANNER);

    const mobileNavigationData: IMobileNavigationEventModel = {
      ActivePage: AARouterURL.ROUTE_PLANNER,
      ActiveTab: AARouterURL.ROUTE_PLANNER
    };
    this.eventsService.dispatch(MobileNavigationEvent.SELECT_MOBILE_MENU, mobileNavigationData);

    this.SwitchButtons('button2');
  }

  SwitchButtons(buttonId) {
    let hideBtn, showBtn;
    if (buttonId === 'button1') {
      document.getElementById('overlay').style.display = 'block';
      showBtn = 'button2';
      hideBtn = 'button1';
    } else {
      showBtn = 'button1';
      hideBtn = 'button2';
      document.getElementById('overlay').style.display = 'none';
    }
    document.getElementById(hideBtn).style.display = 'none';
    document.getElementById(showBtn).style.display = '';
  }
}
